module.exports = __webpack_public_path__ + "img/spinner.bd69c16a.gif";